import React from 'react';
import PropTypes from 'prop-types';
import TotalTable from 'Components/UI/TotalTable';
import { Typography } from '@material-ui/core';
import EditButtonLink from 'Components/Blueprint/UI/EditButtonLink';
import { toNormalCase } from 'Helpers/Formats';
import './index.css';

const Income = ({
  incomeTitle,
  incomeData,
  clientName,
  editLink,
}) => {
  if (incomeData.length === 0) {
    return <div className="content" />;
  }

  return (
    <div className="income">
      <Typography variant="h3">{incomeTitle}</Typography>
      {
        incomeData
          .filter(section => section.value.length > 0)
          .map((income, index) => {
            const dataTotalRemoved = income.value.filter(
              d => d.name.toLowerCase() !== 'total' && d.value > 0,
            );
            const shapedData = dataTotalRemoved.map(incomeSource => ({
              name: toNormalCase(incomeSource.name),
              value: Math.floor(incomeSource.value),
            }));
            if (index === 0) {
              return (
                <div className="content" key={income.name}>
                  <div className="income-type">
                    <span className="income-type-name">
                      {clientName}
                      {editLink && (<EditButtonLink
                        title="Edit Income"
                        to={editLink}
                      />)}
                    </span>
                  </div>
                  <TotalTable tableData={shapedData} showTotalLabel />
                </div>
              );
            }
            return (
              <div className="content" key={income.name}>
                <TotalTable tableData={shapedData} showTotalLabel />
              </div>
            );
          })
      }
    </div>
  );
};

Income.propTypes = {
  editLink: PropTypes.string,
  incomeTitle: PropTypes.string.isRequired,
  incomeData: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      value: PropTypes.arrayOf(
        PropTypes.shape({
          name: PropTypes.string.isRequired,
          value: PropTypes.number.isRequired,
        }),
      ),
    }),
  ),
  clientName: PropTypes.string.isRequired,
};

Income.defaultProps = {
  incomeData: [],
  editLink: null,
};

export default Income;
